import Box from '@mui/material/Box';
import { BoxHeaderCell, BoxHeaderCellProps } from 'common/components/Table/BoxHeaderCell';
import { pxToRem } from 'src/common/utils/fonts';
type SessionHistoryHeaderProps = Pick<BoxHeaderCellProps, 'primaryText' | 'secondaryText'>;

export const SessionHistoryHeader: React.FC<SessionHistoryHeaderProps> = ({
  primaryText,
  secondaryText,
}) => {
  return (
    <Box
      sx={{
        py: 6,
        height: pxToRem(42),
      }}
    >
      <BoxHeaderCell primaryText={primaryText} secondaryText={secondaryText} />
    </Box>
  );
};
